import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import ReduxUtils from '../../utils/ReduxUtils';
import utils from './utils';
import * as ACTIONTYPES from './actionTypes';
/**
 * Contains the action creator functions that update the 'UASignup'
 * slice of the store.
 *
 * @namespace SignupActions
 */

var actions = function actions() {
  _classCallCheck(this, actions);
};

_defineProperty(actions, "setUserInput", function (dispatch, data) {
  dispatch({
    type: ACTIONTYPES.SIGNUP_USER_INPUT,
    payload: data
  });
});

_defineProperty(actions, "setValidationErrors", function (dispatch, errors) {
  dispatch({
    type: ACTIONTYPES.SIGNUP_VALIDATION_ERRORS,
    payload: errors
  });
});

_defineProperty(actions, "setUsernameVisible", function (dispatch, showUsername) {
  dispatch({
    type: ACTIONTYPES.SIGNUP_SET_SHOW_USERNAME_FIELD,
    payload: showUsername
  });
});

_defineProperty(actions, "createTempUser", function (dispatch, callback) {
  var _context;

  ReduxUtils.generateAction(dispatch, _bindInstanceProperty(_context = utils.createTempUserUtil).call(_context, null), ACTIONTYPES.SIGNUP_CREATE_TEMP_USER_ACTION_TYPES, callback);
});

_defineProperty(actions, "postData", function (dispatch, data, callback) {
  var _context2;

  ReduxUtils.generateAction(dispatch, _bindInstanceProperty(_context2 = utils.postSignupDataUtil).call(_context2, null, data), ACTIONTYPES.SIGNUP_POST_ACTION_TYPES, callback);
});

_defineProperty(actions, "resetError", function (dispatch) {
  ReduxUtils.resetErrorAction(dispatch, ACTIONTYPES.SIGNUP_VALIDATION_ERRORS, {});
});

export { actions as default };